import { useQuery } from '@tanstack/react-query'

import { pendingUpload } from '@/lib/pendingUpload'

/**
 * Whether a file picked before sign-in is still waiting.
 *
 * Only for rendering — the funnel's register column appears because of it.
 * The navigation decision reads the store again at the moment it navigates,
 * because an hour-old entry expires on read and a stale `true` here would
 * send someone to a step with nothing to analyse.
 */
export function usePendingUpload() {
  return useQuery({
    queryKey: ['pending-upload'],
    queryFn: () => pendingUpload.take(),
    staleTime: 60_000,
  })
}
